import dataServices from "../../services/DataServices";
import { addItem, getAllItems} from '../../services/NewsDBService';
import { tickImg, crossImg, resolveImage } from "../../images/ImageResolver";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const styles = {
  "background-color":"#fafaff"
};

export const styles2 = {
  "background-color":"#fafaff",
  "color": "#0F1E8A"
};

export function textWithIcon(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if (!content) {
    content = document.createElement("div");
    content.className = 'icon-cell';
    content.style.textAlign = "center";
    
    let img = document.createElement("img");
    img.className = 'icon-cell__img';
    img.width = 16;     // tweak as needed
    img.height = 16;    // tweak as needed
    img.decoding = 'async';
    img.loading = 'eager';
    content.appendChild(img);
    cell.setContent(content);
  }

  const value = String(e.data).toLowerCase();
  const imgEl = content.querySelector('.icon-cell__img');
  imgEl.src = (value === 'yes') ? tickImg : crossImg;
}

export async function fetchData(tabName){
  async function fetchData(uri){
    let url = API_BASE_URL + uri;
    return dataServices.sendGetRequest(url);
  }

  async function fetchAllData(nextPageKey=null){
    let uri = `get-data?tab=${tabName}&limit=300`;
    if(nextPageKey){
      uri += `&nextPageKey=${nextPageKey}`;
    }
    const res = await fetchData(uri);
    await addItem(tabName, res.data.items);
    if(res.data.hasMore){
      return await fetchAllData(res.data.nextPageKey["content"]);
    }
    return res.data.items;
  }

  const fetchDataAsync = async () => {
    let allData = await getAllItems(tabName);
    if(allData && allData.length > 0){
      return allData;
    }else{
      await fetchAllData();
      return await getAllItems(tabName);
    }
  }
  return await fetchDataAsync()
}

export function headerWIthMultipleLines(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myHeaderWithMultipleLines) {
    content = document.createElement("div");
    content._myHeaderWithMultipleLines = true;
    let span = content._span = document.createElement("span");
    span.style.marginRight = "5px";
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
  }
  content._span.textContent = e.columnDef.getName();
  cell.setContent(content);
};

export function headerWithLink(text, i, e) {
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myHeaderWithLink) {
    content = document.createElement("div");
    content._myHeaderWithLink = true;
    let span = content._span = document.createElement("span");
    span.style.marginRight = "5px";
    let image = content._span1 = document.createElement("img");
    image.style.position = "absolute";
    image.style.top = "10px";
    image.style.right = "5px";
    image.style.width = "38px";
    image.src = resolveImage(i);
    let span2 = content._span2 = document.createElement("span");
    span2.style.display = "block";
    span2.style.fontWeight = 400;
    content.appendChild(span);
    content.appendChild(span2);
    content.appendChild(image);
  }

  content._span.textContent = e.columnDef.getName();
  content._span2.textContent = text;
  cell.setContent(content);
};

export function renderPreText(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myRenderPreText) {
    content = document.createElement("div");
    content._myRenderPreText = true;
    let span = content._span = document.createElement("span");
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
  }
  content._span.textContent = e.data;
  content.title = e.data;
  cell.setContent(content);
}

export function onCellClicked(e) {
  const grid = document.getElementById('grid');
  let pos = grid.api.getRelativePosition(e);
  if (pos.sectionType === "content") { // Prevent clicking on header section
    let rowIndex = pos.rowIndex;
    let rowDef = grid.api.getRowDefinition(rowIndex);
    
    if (rowDef) { // Prevent clicking on expanded row
      let rowId = rowDef.getRowId();
      let dv = grid.api.getDataView();
      if (!dv.isRowExpansion(rowId)) {
        dv.toggleRowExpansion(pos.rowIndex);
      }
    }
  }
}

export function cellWithMultipleLines(e) {
  let cell = e.cell;
  var field = e.field;
  var data = e.rowData[field];
  let content = cell.getContent();
  if(!content || !content._myCellWithMultipleLines) {
    content = document.createElement("div");
    content._myCellWithMultipleLines = true;
    let span = content._span = document.createElement("span");
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
  }
  content._span.textContent = data;
  try {
    cell.setTooltip(data);
  } catch (error) {
    console.error('Error setting tooltip:', error);
  }
  cell.setContent(content);
}

export function textWithTextIcon(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if (!content) {
    content = document.createElement("div");
    content.className = 'icon-cell';
    content.style.textAlign = "center";
    let span = document.createElement("span");
    span.className = 'icon-cell__text';
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    content.appendChild(span);
    let img = document.createElement("img");
    img.className = 'icon-cell__img';
    img.width = 16;     // tweak as needed
    img.height = 16;    // tweak as needed
    img.decoding = 'async';
    img.loading = 'eager';
    content.appendChild(img);
    cell.setContent(content);
  }

  const value = String(e.data).toLowerCase();
  const imgEl = content.querySelector('.icon-cell__img');
  const textEl = content.querySelector('.icon-cell__text');
  if(value.includes('unrestricted')) {
    imgEl.style.display = "inline";
    imgEl.src = tickImg;
    textEl.style.display = "none";
  }else if(value.includes('not permitted')) {
    imgEl.style.display = "inline";
    imgEl.src = crossImg;
    textEl.style.display = "none";
  }else{
    textEl.textContent = e.data;
    textEl.style.display = "inline";
    imgEl.style.display = "none";
  }
}

export function headerwithTooltip(tooltipText, e) {
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myHeaderWithTooltip) {
    content = document.createElement("div");
    content._myHeaderWithTooltip = true;
    let span = content._mySpan = document.createElement("span");
    span.style.marginRight = "5px";
    span.style.whiteSpace = "pre-wrap";
    span.style.wordWrap = "break-word";
    let infoIcon =content._myIcon = document.createElement("ef-icon");
    infoIcon.icon = "info";
    infoIcon.style.color = "blue";
    infoIcon.style.fontSize = "14px";
    content.appendChild(span);
    content.appendChild(infoIcon);
    cell.setContent(content);
  }
  content._mySpan.textContent = e.columnDef.getName();
  content._myIcon.title = tooltipText;
  cell.setContent(content);
}



